import BaseModel from './BaseModel';
import Reference from './Reference';

export default class ReferenceDuplicateGroupDto extends BaseModel {
  constructor(data = {}) {
    super(ReferenceDuplicateGroupDto, data);
    this.mainCopyId = data.mainCopyId;
    this.mainCopy = data.mainCopy && new Reference(data.mainCopy);
    this.duplicateIds = data.duplicateIds;
    this.duplicates =
      data.duplicates &&
      data.duplicates.map((it) => new Reference(it));
  }
}
